import React, {Component} from "react";

class Information extends Component{

    constructor(props){
        super(props);
        this.state = {
            
        }
    }

    render(){
        return(
            <div className="breadcrumb-area">
                <div className="information-widget br-10 sec-bg">
                    <div className="information-widget-child ">
                        <h4>Pool Information</h4>
                        {items.map((items) => <InfoCard  key={items.id} title={items.title} info={items.info} /> )}
                    </div>
                    <div className="information-widget-child ">
                        <h4>Token Information</h4>
                        {tokenItems.map((items) => <InfoCard  key={items.id} title={items.title} info={items.info} /> )}
                    </div>
                </div>
            </div>
        );
    }
}

export default Information;

export class InfoCard extends Component{
    render(){
        return(
            <div className="prim-bg info-card">
                <h5>{this.props.title}</h5>
                <p className="sec-txt small-txt">{this.props.info}</p>
            </div>
        )
    }
}

export const items = [
    {
        "id" : "1",
        "title" : "Swap Rate",
        "info" : "1 LOTT = 0.15BUSD",
    },
    {
        "id" : "2",
        "title" : "Sale Start Time",
        "info" : "December 31st, 2020, 12:00 UTC",
    },{
        "id" : "3",
        "title" : "Sale End Time",
        "info" : "December 31st, 2020, 02:00 UTC",
    },
    {
        "id" : "4",
        "title" : "TGE",
        "info" : "December 31st, 2020, 04:00 UTC",
    },
    {
        "id" : "5",
        "title" : "Token Distribution",
        "info" : "33% Unlock at TGE. 67% are vested for 120 days",
    },
    {
        "id" : "6",
        "title" : "Total Raise",
        "info" : "100, 000 BUSD",
    },
    {
        "id" : "7",
        "title" : "Initial Market Cap",
        "info" : "$261,000",
    },
    {
        "id" : "8",
        "title" : "Initial  Token Circulation",
        "info" : "1,195,000/100,000,000",
    },
] 

export const tokenItems = [
    {
        "id" : "1",
        "title" : "Name",
        "info" : "LOTTRADE",
    },
    {
        "id" : "2",
        "title" : "Toekn Symbol",
        "info" : "LOTT",
    },
    {
        "id" : "3",
        "title" : "Total Supply",
        "info" : "100,000,000LOTT",
    },
    {
        "id" : "4",
        "title" : "Token Address",
        "info" : "100,000,000LOTT",
    },
]